module.exports = __webpack_public_path__ + "static/media/3DPPA41.c4f0008e.jpg";